// extracted by mini-css-extract-plugin
export default {"reactPlayer":"Template1_reactPlayer__gWDdf"};